import { render } from "./FooterLinks.vue?vue&type=template&id=afe31170&scoped=true"
const script = {}

import "./FooterLinks.vue?vue&type=style&index=0&id=afe31170&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe31170"]])

export default __exports__